export enum CoordinatesUpdatePriority {
  never,
  byCoords,
  byAddress
}
